/**
 * 그룹 삭제 가드 — 미존재/보드 소속 시 차단(A방식) 단위 테스트.
 */
import { assertGroupDeletable } from './group-delete-guard'

// 번역키를 그대로 돌려주는 t (메시지 파라미터는 [key](params) 형태로 노출해 검증 가능).
const t = (key: string, params?: Record<string, unknown>) => (params ? `${key}(${JSON.stringify(params)})` : key)

describe('assertGroupDeletable', () => {
  test('그룹이 없으면 not-found 로 throw', () => {
    expect(() => assertGroupDeletable(null, 0, t)).toThrow('error.group not found')
    expect(() => assertGroupDeletable(undefined, 0, t)).toThrow('error.group not found')
  })

  test('소속 보드가 있으면 삭제 차단 throw (count 포함)', () => {
    expect(() => assertGroupDeletable({ id: 'g1' }, 3, t)).toThrow('error.group has boards')
    expect(() => assertGroupDeletable({ id: 'g1' }, 3, t)).toThrow('"count":3')
  })

  test('보드 1개여도 차단', () => {
    expect(() => assertGroupDeletable({ id: 'g1' }, 1, t)).toThrow('error.group has boards')
  })

  test('그룹 존재 + 보드 0개면 통과(throw 없음)', () => {
    expect(() => assertGroupDeletable({ id: 'g1' }, 0, t)).not.toThrow()
  })

  test('미존재가 보드-소속보다 우선(count 무관하게 not-found)', () => {
    expect(() => assertGroupDeletable(null, 5, t)).toThrow('error.group not found')
  })
})
